import BannerAd from './BannerAd.js';
import * as Template from '../BannerTemplates.js';

class BannerAdNative extends BannerAd {
    render() {
        const ele = document.getElementById(this._tagName);
        ele.innerHTML = this._getContent(this._adObj, this._tagName, ele);
    }

    _getContent(adObj, pos, ele) {
        const isGridView = ele && ele.hasAttribute('data-new-grid-toggle');

        // premium content position - only in vertical home
        if (this._isContentBoardPlacement(pos)) {
            return Template.getContentBoardTemplate(adObj);
        }

        // SSA Product - only in Bap/Search/*board_2
        if (this._isSSAProduct(adObj)) {
            if (isGridView) {
                return Template.getSSAProductGridView(adObj);
            } else {
                return Template.getSSAProductListView(adObj);
            }
        }

        // SSA Content - in *board_*
        if (this._isSSAContent(adObj)) {
            return Template.getSSAContent(adObj);
        }

        // Native Netboard - in *board_*
        return Template.getNetboardTemplate(adObj);
    }

    _isContentBoardPlacement(pos) {
        return pos && pos === 'contentboard';
    }

    _isSSAProduct(adObj) {
        const isSSAObject = adObj.native.custom.meta_data != null;
        const ssaType = adObj.native.custom.type;
        return isSSAObject && ssaType === 'product';
    }

    _isSSAContent(adObj) {
        const isSSAObject = adObj.native.custom.meta_data != null;
        const ssaType = adObj.native.custom.type;
        return isSSAObject && ssaType === 'content';
    }
}

export default BannerAdNative;



// WEBPACK FOOTER //
// ./services/banner2/types/BannerAdNative.js